/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        version="1.1"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M18.21,15h-2.1V22.5H13V15H11.52V12.36H13V10.64A2.92,2.92,0,0,1,16.14,7.5h2.31v2.57H16.77a.64.64,0,0,0-.66.72v1.56h2.38ZM15,0A15,15,0,1,0,30,15,15,15,0,0,0,15,0Z"
          className="icon-fill"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'FacebookIcon';

export default Icon;
